import { render, staticRenderFns } from "./SectionContact.vue?vue&type=template&id=72fc7ec6&"
import script from "./SectionContact.vue?vue&type=script&lang=js&"
export * from "./SectionContact.vue?vue&type=script&lang=js&"
import style0 from "./SectionContact.vue?vue&type=style&index=0&id=72fc7ec6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports